<template>
  <div>
    <div
      v-if="getServicesLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Services ready...</h3>
        </div>
      </div>
    </div>

    <div class="card card--no-shadow" v-else>
      <div class="card-header">
        <div class="row align-items-center justify-content-between mb-2">
          <div class="col">
            <h1 class="mb-2 font-regular">Services</h1>
          </div>
        </div>
        <!-- <slot name="header">
          <h1 class="card-title">Services Tab</h1>
        </slot> -->
      </div>
      <div class="card-content">
        <div class="card-body">
          <CDataTable
            :items="services"
            :fields="fields"
            :items-per-page="small ? 10 : 5"
            pagination
            sorter
            tableFilter
          >
            <template #img="{item}">
              <td>
                <img
                  :src="item.image_url"
                  alt="logo"
                  style="height: 50px; width: 50px;"
                />
              </td>
            </template>
            <template #category="{item}">
              <td>
                {{ item.category.name }}
              </td>
            </template>
            <template #provider="{item}">
              <td>
                {{ item.provider.name }}
              </td>
            </template>
            <template #action="{item}">
              <td
                class="table--action-mobile"
                v-if="permissions.includes('view-service')"
              >
                <router-link
                  :event="permissions.includes('view-service') ? 'click' : ''"
                  class="button"
                  :class="
                    permissions.includes('view-service')
                      ? ''
                      : 'disabled cursor-not-allowed'
                  "
                  :to="{ name: 'ServiceComponent', params: { slug: item.id } }"
                >
                  View
                </router-link>
              </td>
            </template>
          </CDataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";
const fields = ["img", "name", "category", "status", "action"];
export default {
  name: "Services",
  components: {
    CDataTable
  },
  data() {
    return {
      small: true,
      fields,
      services: [],
      getServicesLoading: true,
      pageLoading: true
    };
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    async getServices() {
      try {
        // this.getServicesLoading = true;
        const response = await ApiService.get("bills/services");

        this.services = response.data.data;
        this.getServicesLoading = false;
      } catch (error) {
        console.log(error.response);
        this.getServicesLoading = false;
      }
    }
  },
  mounted() {
    this.getServices();
  }
};
</script>

<style scoped></style>
